var dashboard = "dashboard";
var dashboardList = "dashboardList";
var stack = "stack";
var list = "list";
var hsplit = "hsplit";
var vsplit = "vsplit";
var win = "window";
var isSplit = function (comp) {
    return comp && (comp.type === hsplit || comp.type === vsplit);
};
export { dashboard, dashboardList, stack, list, hsplit, vsplit, win as window, isSplit };
